import { dataBullseyeHitSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBullseyeHitSolid = /*#__PURE__*/createIcon(dataBullseyeHitSolid)
export default IconBullseyeHitSolid
